export const OPENING_SIDEBAR = 'sidebar/OPENING'
export const CLOSING_SIDEBAR = 'sidebar/CLOSING'

const initialState = {
  open: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case OPENING_SIDEBAR:
      return {
        ...state,
        open: true
      }

    case CLOSING_SIDEBAR:
      return {
        ...state,
        open: false
      }
    default:
      return state
  }
}

export const openSidebar = () => (dispatch) => {
  dispatch({
    type: OPENING_SIDEBAR
  })
}

export const closeSidebar = () => (dispatch) => {
  dispatch({
    type: CLOSING_SIDEBAR
  })
}
